<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
name: "KorisnikBase"
}
</script>

<style scoped>

</style>